import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngxs/store';
import { ShoppingCartState } from '@stores/shopping-cart/shopping-cart.state';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class HasArticleInBasketGuard implements CanActivate {
  constructor(private readonly store: Store, private readonly router: Router) {}

  canActivate(_?: ActivatedRouteSnapshot, __?: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(ShoppingCartState).pipe(
      filter((articles) => !!articles),
      map((articles) => articles.length > 0),
      map((hasArticle) => {
        const dashboardUrlTree = this.router.parseUrl(`/${FeaturesRoutingEnum.Dashboard}`);
        return hasArticle || dashboardUrlTree;
      })
    );
  }
}
